<div class="mx-auto  lg:w-2/3 md:w-full ">
    <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
        <h1 class="text-3xl font-bold mb-6 p-5">Rejoindre la communauté Discord</h1>
        <p-button 
            label="Rejoindre" 
            icon="pi pi-discord"
            (onClick)="goToDiscord()"
            styleClass="p-button-lg">
        </p-button>
    </div>
    <div class="bg-white shadow rounded-lg p-6 mb-8">
        <div class="text-center mb-6">
            <h1 class="text-3xl font-bold mb-2">Liste de projets</h1>
            <p class="text-gray-600">Découvrez nos derniers projets d'investissement</p>
        </div>
        <div *ngIf="errorMessage()" class="mb-4">
            <p-message 
                severity="error" 
                [text]="errorMessage()"
                styleClass="w-full">
            </p-message>
            <div class="text-center mt-4">
                <p-button 
                    label="Réessayer" 
                    icon="pi pi-refresh"
                    (onClick)="loadProjects()"
                    styleClass="p-button-outlined">
                </p-button>
            </div>
        </div>
        <div *ngIf="isLoading() && !errorMessage()">
            <p-skeleton height="60px" styleClass="mb-3"></p-skeleton>
            <p-skeleton height="60px" styleClass="mb-3"></p-skeleton>
            <p-skeleton height="60px"></p-skeleton>
        </div>
        <div *ngIf="!isLoading() && !errorMessage()">
            <div *ngIf="projects().length === 0" class="text-center py-8">
                <i class="pi pi-inbox text-6xl text-gray-300 mb-4"></i>
                <h3 class="text-xl font-semibold text-gray-600 mb-2">Aucun projet disponible</h3>
                <p class="text-gray-500">Les projets d'investissement seront bientôt disponibles.</p>
            </div>
            <p-accordion *ngIf="projects().length > 0" [value]="'0'">
                <p-accordion-panel 
                    *ngFor="let project of projects(); let i = index; "
                    [value]="i.toString()">
                    <p-accordion-header>
                        <div class="flex justify-between items-center w-full pr-4">
                            <div class="flex flex-col items-start">
                                <span class="font-semibold text-lg">{{ project.name }}</span>
                                <small class="text-gray-500">
                                    Créé le {{ formatDate(project.created_at) }}
                                </small>
                            </div>
                            <div class="flex items-center">
                                <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
                                    Projet #{{i + 1 }}
                                </span>
                            </div>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="space-y-4">
                            <div class="bg-gray-50 p-4 rounded-lg">
                                <h4 class="font-semibold mb-2">Description du projet</h4>
                                <p class="text-gray-700 leading-relaxed">
                                    {{ project.description }}
                                </p>
                            </div>
                        </div>
                    </p-accordion-content>
                    <div class="mb-4 flex justify-center">
                        <p-button
                            label="Contacter le support pour ce projet"
                            icon="pi pi-envelope"
                            (onClick)="contactSupport(project)"
                        >
                        </p-button>
                    </div>
                </p-accordion-panel>
            </p-accordion>
        </div>
    </div>
</div>